import { n } from "./Logger-CmiOOsKC.js";
import { t as d } from "./tracebehavior-5_qSKjs6.js";
import { c as _ } from "./playable-tG_Q2o5X.js";
import { Observable as u } from "@babylonjs/core/Misc/observable.js";
var y = class extends d {
  static behaviorType = "AudioClip";
  _audio = null;
  _resolvedUrl = null;
  _ownsObjectUrl = !1;
  _loaded = !1;
  _pendingPlayback = !1;
  _cancelBlockedRetry = null;
  _playRequest = 0;
  _loadGeneration = 0;
  _waitRemaining = null;
  _waitObserver = null;
  constructor(t, i) {
    super(t, i);
    const e = this._startAt();
    this._waitRemaining = e > 0 ? e : null;
  }
  onMediaElementReadyObservable = new u();
  getMediaElement() {
    return this._audio;
  }
  load() {
    let t = this.sceneObject.src ?? "";
    const i = this.resources.getAsset(t);
    if (i ? (t = URL.createObjectURL(i), this._ownsObjectUrl = !0) : t = this.resources.resolveAssetUrl(t) ?? t, !t)
      return n.warn(`[AudioClip] No audio source specified for "${this.sceneObject.name}"`), Promise.resolve();
    this._resolvedUrl = t;
    const e = new window.Audio();
    e.preload = "metadata", e.crossOrigin = "anonymous", e.src = t, e.loop = this._resolved.loop !== !1, this._audio = e, this._startAt() !== 0 && this._positionAt(0);
    const s = () => {
      this._loaded || (this._loaded = !0, this.onMediaElementReadyObservable.notifyObservers(e), this._startPlaybackIfDue());
    };
    return e.readyState >= 1 ? s() : e.addEventListener("loadedmetadata", s, { once: !0 }), e.addEventListener("error", () => {
      n.warn(`[AudioClip] Failed to load "${this.sceneObject.name}": ${e.error?.message ?? "unknown error"}`);
    }, { once: !0 }), Promise.resolve();
  }
  async applyCommit(t, i) {
    if (this._audio && (this._audio.loop = this._resolved.loop !== !1), "startAt" in t || l(i.startAt) !== this._startAt()) {
      const e = l(i.startAt), s = this._waitRemaining !== null ? e - this._waitRemaining : (this._audio?.currentTime ?? 0) + e;
      this._seekTimeline(Math.max(0, s));
    }
  }
  onPlayModeChanged(t) {
    t || (this._pendingPlayback = !1, this._stopWait()), this._audio && (t ? this._startPlaybackIfDue() : (this._dropBlockedRetry(), this._audio.pause(), this._positionAt(0)));
  }
  onEffectiveActiveChanged(t) {
    if (this._audio) {
      if (!t) {
        this._stopWait(), this._dropBlockedRetry(), this._audio.pause();
        return;
      }
      this._startPlaybackIfDue();
    }
  }
  _shouldStartPlayback() {
    return this._pendingPlayback || this.playMode && this._resolved.playOnStart !== !1 && this.sceneObject.effectiveActive;
  }
  _startPlaybackIfDue() {
    this._shouldStartPlayback() && (this._pendingPlayback = !1, this._startPlayback());
  }
  play() {
    if (!this._audio) {
      this._pendingPlayback = !0;
      return;
    }
    if (this._waitRemaining !== null) {
      this._startWait();
      return;
    }
    this._audio.loop = this._resolved.loop !== !1, this._tryPlay();
  }
  pause() {
    this._pendingPlayback = !1, this._stopWait(), this._dropBlockedRetry(), this._audio?.pause();
  }
  stop() {
    this._pendingPlayback = !1, this._stopWait(), this._dropBlockedRetry(), this._audio?.pause(), this._positionAt(0);
  }
  seek(t, i = "absolute") {
    const e = i === "relative" ? this._currentClipTime() + t : t;
    this._seekTimeline(Math.max(0, e));
  }
  getClockTime() {
    return this._waitRemaining !== null ? null : _(this._audio, this._startAt());
  }
  setVolume(t) {
    this._audio && (this._audio.volume = Math.max(0, Math.min(1, t)));
  }
  isPlaying() {
    return !!this._audio && !this._audio.paused && !this._audio.ended;
  }
  getVolume() {
    return this._audio?.volume ?? 1;
  }
  setSource(t) {
    if (!t)
      return n.warn(`[AudioClip] setSource called with empty URL on "${this.sceneObject.name}"`), Promise.resolve();
    const i = this.resources.getAsset(t);
    if (!i && this._resolvedUrl === t) return Promise.resolve();
    let e = t, s = !1;
    i && (e = URL.createObjectURL(i), s = !0), this._dropBlockedRetry(), this._stopWait(), this._audio && (this._audio.pause(), this._audio.removeAttribute("src"), this._audio.load()), this._ownsObjectUrl && this._resolvedUrl && URL.revokeObjectURL(this._resolvedUrl), this._resolvedUrl = e, this._ownsObjectUrl = s, this._loaded = !1;
    const r = ++this._loadGeneration, a = this._audio ?? new window.Audio();
    return this._audio || (a.preload = "metadata", a.crossOrigin = "anonymous", this._audio = a), a.src = e, a.loop = this._resolved.loop !== !1, this._positionAt(0), new Promise((o) => {
      const h = () => {
        if (this._loadGeneration !== r) {
          o();
          return;
        }
        if (this._loaded) {
          o();
          return;
        }
        this._loaded = !0, this.onMediaElementReadyObservable.notifyObservers(a), o();
      };
      a.readyState >= 1 ? h() : a.addEventListener("loadedmetadata", h, { once: !0 });
    });
  }
  _tryPlay() {
    const t = this._audio;
    if (!t) return;
    this._dropBlockedRetry();
    const i = this._playRequest, e = this.sceneObject.traceScene.getAudioManager();
    e.resume(), t.play().catch((s) => {
      s?.name === "NotAllowedError" && (this._audio !== t || this._playRequest !== i || (this._cancelBlockedRetry = e.retryOnGesture(() => {
        this._cancelBlockedRetry = null, this._audio === t && t.paused && t.play().catch(() => {
        });
      })));
    });
  }
  _startAt() {
    return l(this._resolved.startAt);
  }
  _currentClipTime() {
    const t = this._startAt();
    return this._waitRemaining !== null ? t - this._waitRemaining : (this._audio?.currentTime ?? 0) + t;
  }
  _positionAt(t) {
    const i = this._startAt();
    if (t < i) {
      this._waitRemaining = i - t, this._audio && (this._audio.paused || (this._dropBlockedRetry(), this._audio.pause()), this._audio.currentTime = 0);
      return;
    }
    if (this._waitRemaining = null, this._audio) {
      const e = t - i, s = this._audio.duration, r = isFinite(s) ? Math.min(e, s) : e;
      this._audio.currentTime = Math.max(0, r);
    }
  }
  _seekTimeline(t) {
    const i = this._waitObserver !== null || this.isPlaying();
    this._positionAt(t), i && (this._waitRemaining !== null ? this._startWait() : this._waitObserver && (this._stopWait(), this._tryPlay()));
  }
  _startPlayback() {
    this._waitRemaining !== null ? this._startWait() : this._tryPlay();
  }
  _startWait() {
    this._waitObserver || !this.scene || (this._waitObserver = this.scene.onBeforeRenderObservable.add(() => {
      if (this._waitRemaining === null) {
        this._stopWait();
        return;
      }
      if (this._waitRemaining -= this.scene.getEngine().getDeltaTime() / 1e3, this._waitRemaining > 0) return;
      const t = -this._waitRemaining;
      if (this._stopWait(), this._positionAt(this._startAt() + t), !this._audio) {
        this._pendingPlayback = !0;
        return;
      }
      this._audio.loop = this._resolved.loop !== !1, this._tryPlay();
    }));
  }
  _stopWait() {
    this._waitObserver && (this.scene?.onBeforeRenderObservable.remove(this._waitObserver), this._waitObserver = null);
  }
  _dropBlockedRetry() {
    this._playRequest++;
    const t = this._cancelBlockedRetry;
    this._cancelBlockedRetry = null, t?.();
  }
  onDetach() {
    this._stopWait(), this._dropBlockedRetry(), this._audio && (this._audio.pause(), this._audio.removeAttribute("src"), this._audio.load(), this._audio = null), this._ownsObjectUrl && this._resolvedUrl && URL.revokeObjectURL(this._resolvedUrl), this._resolvedUrl = null, this._ownsObjectUrl = !1, this._loaded = !1, this.onMediaElementReadyObservable.clear();
  }
};
function l(t) {
  return typeof t == "number" && Number.isFinite(t) ? t : 0;
}
export {
  y as t
};

//# sourceMappingURL=audioclip-D2YGwkWS.js.map